import { SEARCH_ENGINES } from '~/utils/navigationContext';

export const DEFAULT_SOURCE_MEDIUM = '(direct) / (none)';

function fromUtmParams(utmSource?: string, utmMedium?: string): string | null {
  if (!utmSource && !utmMedium) return null;

  const source = utmSource?.toLowerCase() ?? '(not set)';
  const medium = utmMedium?.toLowerCase() ?? '(not set)';

  return `${source} / ${medium}`;
}

function fromReferrer(referrer: string, currentHostname: string): string {
  if (!referrer) return DEFAULT_SOURCE_MEDIUM;

  try {
    const hostname = new URL(referrer).hostname.toLowerCase();
    const stripWww = (h: string) => h.replace(/^www\./, '');

    if (stripWww(hostname) === stripWww(currentHostname))
      return DEFAULT_SOURCE_MEDIUM;

    const engine = SEARCH_ENGINES.find((e) => hostname.includes(e));
    if (engine) return `${engine} / organic`;

    return `${hostname.replace(/^www\./, '')} / referral`;
  } catch {
    return DEFAULT_SOURCE_MEDIUM;
  }
}

function fromSearchParams(search: string): string | null {
  const params = new URLSearchParams(search);
  const utmSource = params.get('utm_source') ?? undefined;
  const utmMedium = params.get('utm_medium') ?? undefined;

  return fromUtmParams(utmSource, utmMedium);
}

export function deriveSourceMedium(
  search: string,
  referrer: string,
  currentHostname: string
): string {
  return fromSearchParams(search) ?? fromReferrer(referrer, currentHostname);
}
